import { ICellRendererParams } from 'ag-grid-community';

interface IProps extends ICellRendererParams { }

export const SaturationSummaryRenderer = (props: IProps) => {
    if (props.data.isSummary) {
        switch (props.column.getColDef().field) {

            //Show percentage only
            case 'voucherProgramUtilization':
            case 'pwlUtilization':
            case 'dsdUtilization':
            case 'shbUtilized':
            case 'automatedDonorFollowUpFullyUtilized':
            case 'automatedDonorFollowUpUtilization':
            case 'kidneyForLifeUtilization':
                return (
                    <span>{props.value.percent.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}%</span>
                );

            //show total only
            case 'ubpInvTrigCount':
            case 'shbEligibleSwaps':
            case 'automatedCollectionsAndClearingInvoiceCount':
            case 'directStreamlinedSerologyCount':
            case 'homeBloodDrawCount':
            case 'lowExpletTxpCountL12M':
            case 'saturationVariance':
            case 'kidneyForLifeSuccess':
                return (
                    <span>{props.value.total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                );

            //show percent and total
            case 'saturationTotal':
            case 'acceptingKflPatientReferrals':
            case 'saturationAnnualGoal':
                return (
                    <span>
                        {props.value.percent.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}%{' '}
                        ({props.value.total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })})
                    </span>
                );

            case 'dashUtilization':
                if (props.value >= 1) {
                    return (
                        <span>{props.value.percent.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}%</span>
                    );
                } else {
                    return (
                        <span>(&lt; 1%)</span>
                    );
                }

            default:
                const p = props.value ? (props.value.percent * 100).toFixed(0) : '';
                const t = props.value ? props.value.total : 0;
                const a = props.value ? (props.value.average ? props.value.average : 0) : 0;

                if (props.value && props.value.average != null) {
                    return (
                        <span>{t.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span>
                    );
                }

                return (
                    <span>{p}% ({t})</span>
                );
        }
    }

    if (props.data.isProductOwner) {
        const i = props.value ? props.value.initials : '';
        const n = props.value ? props.value.name : '';
        const a = props.value ? props.value.isActive : false;

        return (
            <span style={{ backgroundColor: a ? 'darkgreen' : null, color: a ? 'white' : null }} title={a ? 'Product is active' : 'Product is inactive'}>&nbsp;{i}&nbsp;</span>
        )
    }

    return null;
}